import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Moon, Home, Star, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import nuiteeDomicilePopup from '../assets/nuitee-domicile-popup.webp';

const ServicePopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Show popup after 2 seconds
    const timer = setTimeout(() => {
      // Check if we've already shown it in this session to avoid annoyance
      const hasSeenPopup = sessionStorage.getItem('hasSeenPensionPopup');
      if (!hasSeenPopup) {
        setIsOpen(true);
        sessionStorage.setItem('hasSeenPensionPopup', 'true');
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

   return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setIsOpen(false)}
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[100] flex items-center justify-center p-4"
        >
          {/* Popup Card */}
          <motion.div
  initial={{ opacity: 0, scale: 0.9, y: 20 }}
  animate={{ opacity: 1, scale: 1, y: 0 }}
  exit={{ opacity: 0, scale: 0.9, y: 20 }}
  onClick={(e) => e.stopPropagation()}
  className="bg-white w-full max-w-[90%] md:max-w-4xl rounded-[2rem] shadow-2xl overflow-hidden overflow-y-auto flex flex-col md:flex-row max-h-[90vh]"
>
            {/* Image Section */}
            <div className="md:w-1/2 relative h-64 xs:h-72 sm:h-80 md:h-auto bg-stone-100">
              <img 
                src={nuiteeDomicilePopup} 
                alt="Gardiennage avec nuitée à domicile — membre de l'équipe avec un chien" 
                className="w-full h-full object-cover object-[center_38%]"
              />
              <div className="absolute bottom-4 left-4 md:top-4 md:bottom-auto bg-white/90 backdrop-blur-md px-4 py-2 rounded-full text-teal-700 font-bold text-sm shadow-sm flex items-center gap-2">
                <Star size={16} fill="currentColor" />
                Nouveau Service
              </div>
            </div>

            {/* Content Section */}
            <div className="md:w-1/2 p-5 sm:p-6 md:p-12 flex flex-col justify-center relative">
              <button 
                onClick={() => setIsOpen(false)}
                className="absolute top-6 right-6 p-2 hover:bg-stone-100 rounded-full transition-colors text-stone-400 hover:text-stone-600"
              >
                <X size={24} />
              </button>

              <div className="mb-3">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-teal-100 text-teal-600 rounded-2xl mb-4">
                  <Home size={24} />
                </div>
                <h3 className="text-3xl font-bold text-stone-900 mb-3">
                  Pension & Nuitée <br/>
                  <span className="text-teal-600">à Domicile</span>
                </h3>
                <p className="text-stone-600 text-base sm:text-lg leading-relaxed">
                  Votre animal est stressé par les déplacements ? Nos gardiens viennent <strong>dormir chez vous</strong> !
                </p>
              </div>

              <div className="space-y-2 mb-5">
                <div className="flex items-start gap-3">
                  <div className="mt-1 bg-orange-100 p-1 rounded-full text-orange-600">
                    <Moon size={16} />
                  </div>
                  <p className="text-stone-600 text-sm">Présence rassurante toute la nuit dans son environnement familier.</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="mt-1 bg-teal-100 p-1 rounded-full text-teal-600">
                    <Heart size={16} />
                  </div>
                  <p className="text-stone-600 text-sm">Zéro stress : il garde ses repères, son lit et sa routine habituelle.</p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/services#pension" 
                  onClick={() => setIsOpen(false)}
                  className="flex-1 bg-teal-600 text-white text-center px-6 py-3.5 rounded-xl font-bold hover:bg-teal-700 transition-all shadow-lg shadow-teal-600/20 hover:-translate-y-0.5"
                >
                  En savoir plus
                </Link>
                <Link 
                  to="/contact"
                  onClick={() => setIsOpen(false)} 
                  className="flex-1 bg-white border-2 border-stone-200 text-stone-700 text-center px-6 py-3.5 rounded-xl font-bold hover:bg-stone-50 hover:border-stone-300 transition-all"
                >
                  Réserver
                </Link>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ServicePopup;
